import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";

interface DateRangeProps {
  headers: string;
  onDateChange: (start: string, end: string) => void;
}

const DateRange: React.FC<DateRangeProps> = ({ headers, onDateChange }) => {
  const [startDate, setStartDate] = useState<string>(getFirstDayOfMonth());
  const [endDate, setEndDate] = useState<string>(getCurrentDate());

  function getFirstDayOfMonth(): string {
    const today: Date = new Date();
    const firstDayOfMonth: Date = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );
    return formatDate(firstDayOfMonth);
  }

  function getCurrentDate(): string {
    const today: Date = new Date();
    return formatDate(today);
  }

  function formatDate(date: Date): string {
    const year: number = date.getFullYear();
    let month: number | string = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    const day: number = date.getDate();
    return `${year}-${month}-${day < 10 ? `0${day}` : day}`;
  }

  useEffect(() => {
    onDateChange(startDate, endDate);
  }, [startDate, endDate]);

  return (
    <>
      <div className="date-Picker">
        <h3 className="header-date">{headers}</h3>
        <label htmlFor="start date">Início</label>
        <input
          type="date"
          className="startDate"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        ></input>

        <label htmlFor="end date">Fim</label>
        <input
          type="date"
          className="endDate"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        ></input>
      </div>
    </>
  );
};

export default DateRange;
